<template>
  <svg fill="#000000" height="26" width="26" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
       viewBox="0 0 512 512" xml:space="preserve">
<g transform="translate(1 1)">
	<g>
		<g>
			<path d="M50.2,246.467h34.133H203.8h34.133c5.12,0,8.533-3.413,8.533-8.533V50.2c0-5.12-3.413-8.533-8.533-8.533H50.2
				c-5.12,0-8.533,3.413-8.533,8.533v187.733C41.667,243.053,45.08,246.467,50.2,246.467z M92.867,229.4v-5.973
				c0-28.16,20.48-51.2,46.08-53.76c3.413,0,6.827,0,10.24,0c25.6,2.56,46.08,26.453,46.08,53.76v5.973H92.867z M144.067,152.6
				c-14.507,0-25.6-11.093-25.6-25.6s11.093-25.6,25.6-25.6c14.507,0,25.6,11.093,25.6,25.6S158.573,152.6,144.067,152.6z
				 M58.733,58.733H229.4V229.4h-17.92v-5.973c0-28.284-15.726-53.004-38.953-64.419c8.756-7.765,14.206-19.141,14.206-32.008
				c0-23.893-18.773-42.667-42.667-42.667c-23.893,0-42.667,18.773-42.667,42.667c0,12.777,5.371,24.086,14.02,31.847
				c-23.239,11.344-39.62,36.165-39.62,64.58v5.973H58.733V58.733z"/>
      <path d="M374.467,41.667H280.6c-5.12,0-8.533,3.413-8.533,8.533v34.133c0,5.12,3.413,8.533,8.533,8.533h93.867
				c5.12,0,8.533-3.413,8.533-8.533V50.2C383,45.08,379.587,41.667,374.467,41.667z M365.933,75.8h-76.8V58.733h76.8V75.8z"/>
      <path d="M374.467,118.467H280.6c-5.12,0-8.533,3.413-8.533,8.533v34.133c0,5.12,3.413,8.533,8.533,8.533h93.867
				c5.12,0,8.533-3.413,8.533-8.533V127C383,121.88,379.587,118.467,374.467,118.467z M365.933,152.6h-76.8v-17.067h76.8V152.6z"/>
      <path d="M374.467,195.267H280.6c-5.12,0-8.533,3.413-8.533,8.533v34.133c0,5.12,3.413,8.533,8.533,8.533h93.867
				c5.12,0,8.533-3.413,8.533-8.533V203.8C383,198.68,379.587,195.267,374.467,195.267z M365.933,229.4h-76.8v-17.067h76.8V229.4z"
      />
      <path d="M374.467,272.067H50.2c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h324.267c5.12,0,8.533-3.413,8.533-8.533
				S379.587,272.067,374.467,272.067z"/>
      <path d="M186.733,314.733H50.2c-5.12,0-8.533,3.413-8.533,8.533S45.08,331.8,50.2,331.8h136.533c5.12,0,8.533-3.413,8.533-8.533
				S191.853,314.733,186.733,314.733z"/>
      <path d="M374.467,314.733H237.933c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h136.533
				c5.12,0,8.533-3.413,8.533-8.533S379.587,314.733,374.467,314.733z"/>
      <path d="M186.733,357.4H50.2c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h136.533c5.12,0,8.533-3.413,8.533-8.533
				S191.853,357.4,186.733,357.4z"/>
      <path d="M374.467,357.4H237.933c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h136.533
				c5.12,0,8.533-3.413,8.533-8.533S379.587,357.4,374.467,357.4z"/>
      <path d="M186.733,400.067H50.2c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h136.533c5.12,0,8.533-3.413,8.533-8.533
				S191.853,400.067,186.733,400.067z"/>
      <path d="M374.467,400.067H237.933c-5.12,0-8.533,3.413-8.533,8.533s3.413,8.533,8.533,8.533h136.533
				c5.12,0,8.533-3.413,8.533-8.533S379.587,400.067,374.467,400.067z"/>
      <path d="M186.733,442.733H50.2c-5.12,0-8.533,3.413-8.533,8.533c0,5.12,3.413,8.533,8.533,8.533h136.533
				c5.12,0,8.533-3.413,8.533-8.533C195.267,446.147,191.853,442.733,186.733,442.733z"/>
      <path d="M374.467,442.733H237.933c-5.12,0-8.533,3.413-8.533,8.533c0,5.12,3.413,8.533,8.533,8.533h136.533
				c5.12,0,8.533-3.413,8.533-8.533C383,446.147,379.587,442.733,374.467,442.733z"/>
      <path d="M485.4,272.067h-59.733V24.6c0-14.507-11.093-25.6-25.6-25.6H24.6C10.093-1-1,10.093-1,24.6v460.8
				c0,14.507,11.093,25.6,25.6,25.6h435.2c28.16,0,51.2-23.04,51.2-51.2V297.667C511,283.16,499.907,272.067,485.4,272.067z
				 M24.6,493.933c-4.267,0-8.533-3.413-8.533-8.533V24.6c0-4.267,4.267-8.533,8.533-8.533h375.467c4.267,0,8.533,3.413,8.533,8.533
				v256v179.2c0,12.8,4.267,24.747,12.8,34.133H24.6z M493.933,459.8c0,18.773-15.36,34.133-34.133,34.133
				c-18.773,0-34.133-15.36-34.133-34.133V289.133H485.4c4.267,0,8.533,3.413,8.533,8.533V459.8z"/>
		</g>
	</g>
</g>
</svg>
</template>
